/*A Pupgevity theme JS — no dependencies, deferred. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // The theme editor re-runs init() whenever a section reloads. This keeps us
  // from binding the same listener to the same element twice.
  function claim(el, key) {
    if (!el) return false;
    var flag = 'pgInit' + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = '1';
    return true;
  }

  /* ---------- Mobile drawer ---------------------------------------------- */
  function initDrawer() {
    var drawer = document.getElementById('pg-drawer');
    if (!claim(drawer, 'Drawer')) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute('data-open', 'true');
      document.body.setAttribute('data-scroll-lock', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var first = drawer.querySelector('a, button');
      if (first) first.focus({ preventScroll: true });
    }
    function close() {
      drawer.setAttribute('data-open', 'false');
      document.body.removeAttribute('data-scroll-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) return;
      if (e.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
    });
    // Trap focus inside the panel while open
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || drawer.getAttribute('data-open') !== 'true') return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Scroll reveal ---------------------------------------------- */
  function initReveal() {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Accordion: only one open at a time (per group) -------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion][data-single="true"]').forEach(function (group) {
      if (!claim(group, 'Acc')) return;
      group.addEventListener('toggle', function (e) {
        var item = e.target;
        if (item.tagName !== 'DETAILS' || !item.open) return;
        group.querySelectorAll('details[open]').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }, true);
    });
  }

  /* ---------- Product gallery -------------------------------------------- */
  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || thumbs.length < 2) return;
      if (!claim(gallery, 'Gallery')) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) {
            main.src = src;
            if (srcset) main.srcset = srcset;
            main.alt = alt;
          }
          thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- Quantity steppers ------------------------------------------ */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input || !claim(wrap, 'Qty')) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Variant picker --------------------------------------------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl || !claim(picker, 'Variants')) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = picker.closest('form') || document.querySelector('[data-product-form]');
      var idInput = picker.querySelector('[data-variant-id]') ||
        (form && form.querySelector('[data-variant-id]'));
      var priceNow = picker.querySelector('[data-price-now]') || document.querySelector('[data-price-now]');
      var priceWas = document.querySelector('[data-price-was]');
      var submit = form && form.querySelector('[data-atc-submit]');
      var stickyPrice = document.querySelector("[data-sticky-price]");

      function currentSelection() {
        return Array.prototype.map.call(
          picker.querySelectorAll('[data-option-group]'),
          function (group) {
            var active = group.querySelector('[aria-pressed="true"]');
            return active ? active.getAttribute('data-value') : null;
          }
        );
      }

      function update() {
        var sel = currentSelection();
        var match = variants.find(function (v) {
          return sel.every(function (val, i) { return val === null || v.options[i] === val; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        // Prices are pre-formatted by Liquid, so currency and locale stay correct.
        if (priceNow) priceNow.textContent = match.price_html;
        if (stickyPrice) stickyPrice.textContent = match.price_html;
        if (priceWas) {
          if (match.compare_html) {
            priceWas.textContent = match.compare_html;
            priceWas.hidden = false;
          } else {
            priceWas.textContent = '';
            priceWas.hidden = true;
          }
        }
        [submit, document.querySelector('[data-sticky-submit]')].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !match.available;
          btn.textContent = match.available
            ? btn.getAttribute('data-label-available')
            : btn.getAttribute('data-label-soldout');
        });
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.querySelectorAll('[data-option-group] [data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-option-group]');
          group.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          update();
        });
      });
      update();
    });
  }

  /* ---------- Sticky add-to-cart ----------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !claim(bar, 'Sticky')) return;

    function show(v) { bar.setAttribute('data-visible', v ? 'true' : 'false'); }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        // Show the bar once the in-page button has scrolled out of view upward.
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(anchor);
    }

    // The sticky button just submits the real product form.
    var trigger = bar.querySelector('[data-sticky-submit]');
    var form = document.querySelector('[data-product-form]');
    if (trigger && form) {
      trigger.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ---------- Header shadow on scroll ------------------------------------ */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!claim(header, 'HeaderScroll')) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        header.setAttribute('data-scrolled', window.scrollY > 8 ? 'true' : 'false');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initDrawer();
    initReveal();
    initAccordions();
    initGallery();
    initQty();
    initVariants();
    initStickyAtc();
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
